/* eslint-disable no-undef */
const settings = {
  host: process.env.REACT_APP_API_HOST,
};
  
export default Object.freeze({
  host: settings.host,
});